<div
  *ngIf="!isLoading"
  class="watchlist-menu-section"
  [ngClass]="{
    'create-new-modal-watchlist-menu-section': isCreateNewModalIndustryMenu
  }"
>
  <div
    class="watchlist-menu-content"
    [ngClass]="{
      'create-new-modal-watchlist-menu-content': isCreateNewModalIndustryMenu
    }"
  >
    <div
      class="watchlist-menu"
      [ngClass]="{
        'create-new-modal-watchlist-menu': isCreateNewModalIndustryMenu
      }"
    >
      <!-- <app-menu-list
        [data]="data"
        (onListClick)="handleListClick($event)"
      ></app-menu-list> -->
      <ul *ngIf="!isLoading" class="menu-list">
        <li
          *ngFor="let item of data"
          (click)="handleListClick(item)"
          class="menu-list-item"
          [ngClass]="{ active: item.selected }"
        >
          <span
            class="menu-item"
            [ngClass]="{ 'menu-highlight-text': searchedValue }"
            [innerHtml]="item.label | textHighlight: searchedValue"
          >
          </span>
          <span *ngIf="item.count !== undefined">&nbsp;({{ item.count }})</span>
        </li>
      </ul>

      <app-custom-skeleton
        *ngIf="isLoading"
        [customSkeletonConfig]="skeletonDefaultConfig"
        ngClass="menu-skeleton"
      ></app-custom-skeleton>
    </div>
    <div
      class="watchlist-geo-mcap-container"
      [ngClass]="{
        'geo-mcap-disabled': !isWatchlistSelected,
        'create-new-modal-watchlist-geo-mcap-container':
          isCreateNewModalIndustryMenu
      }"
    >
      <app-market-cap-filter
        [isLoading]="isMcapGeoDataLoading"
        [marketCapData]="[marketCapData]"
        [selectedMarketCaps]="selectedMarketCaps"
        (onMarketCapSelect)="handleMarketCapChange($event)"
      ></app-market-cap-filter>
      <app-geography-filter
        [isLoading]="isMcapGeoDataLoading"
        [geographyData]="geographyData"
        [otherGeoLen]="otherGeoLen"
        (geographySelect)="handleGeographyChange($event)"
      ></app-geography-filter>
    </div>
  </div>
  <div class="watchlist-menu-footer">
    {{ totalTickerCount }} companies selected
    <va-button
      btnType="outline"
      size="medium"
      (onClick)="handleCancelButtonClick()"
      class="mr-8 ml-8"
      >Cancel</va-button
    >
    <va-button
      btnType="solid"
      size="medium"
      [isDisabled]="!totalTickerCount || totalTickerCount <= 0"
      (onClick)="handleApplyButtonClick()"
      >Apply</va-button
    >
  </div>
</div>

<app-custom-skeleton
  *ngIf="isLoading"
  [customSkeletonConfig]="skeletonDefaultConfig"
  ngClass="menu-skeleton"
></app-custom-skeleton>
